import * as t from "io-ts";
import { FormShortId } from "../../../../types/ids";
import { BadResponseBodyError } from "../../../../bad-response-body-error";
import { FormHandle } from "../../../../types/form/handle";
import { PlainMemberEmail } from "../../../../types/user/memberEmail";

export const RequestCancelSiteQuery = t.type({
  handle: FormHandle,
  shortId: FormShortId,
});
export type RequestCancelSiteQuery = t.TypeOf<typeof RequestCancelSiteQuery>;

export const RequestCancelSiteRequest = t.type({
  email: PlainMemberEmail,
});
export type RequestCancelSiteRequest = t.TypeOf<typeof RequestCancelSiteRequest>;

export const RequestCancelSiteResponse = t.union([
  t.type({
    type: t.literal("not-found"),
  }),
  t.type({
    type: t.literal("mail-failed"),
  }),
  t.type({
    type: t.literal("unexpected-error"),
  }),
  t.type({
    type: t.literal("success"),
    code: t.string,
  }),
]);
export type RequestCancelSiteResponse = t.TypeOf<typeof RequestCancelSiteResponse>;
export type RequestCancelSiteResponseOutput = t.OutputOf<typeof RequestCancelSiteResponse>;

export async function requestCancelSite(request: RequestCancelSiteQuery & RequestCancelSiteRequest): Promise<RequestCancelSiteResponse> {
  try {
    const res = await fetch(`/api/cancel/${FormHandle.encode(request.handle)}/${FormShortId.encode(request.shortId)}/request-site`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(RequestCancelSiteRequest.encode({ email: request.email })),
    });

    const data = BadResponseBodyError.throwIfLeft(res.status,
      RequestCancelSiteResponse.decode(await res.json()));
    return data ?? null;
  } catch {
    return { type: "unexpected-error" };
  }
}
